<template>
  <component
    :is="isLoaded"
    :options="pdfOptions"
    offscreenPages="1"
    v-on:pageChanged="onPageChanged"
  ></component>
</template>

<script>
import { db } from "@/main";
import axios from "axios";
import qs from "querystring";

export default {
  data: () => ({
    pdf: null,
  }),
  components: {
    LazyPdfVuer: () => import("@/components/viewer/LazyPdfVuer.vue"),
  },
  props: {
    paperDate: {
      type: Date,
      default: new Date(),
    },
  },
  computed: {
    pdfOptions: function () {
      return {
        url: `${this.apibase}${this.pdf}`,
        //url: "paper.pdf",
        // httpHeaders: {
        //   Authorization: "",
        //   "access-control-allow-headers": "Content-Type, If-Modified-Since",
        //   "access-control-allow-methods": "GET, HEAD",
        //   "access-control-allow-origin": "*",
        // },
      };
    },
    isLoaded: function () {
      if (this.pdf !== null) {
        return "LazyPdfVuer";
      } else {
        return null;
      }
    },
  },
  methods: {
    async getPaper(date) {
		
		var publishing_time = "05:30:00";
		
		var user_date = new Date(date);
		var today = new Date();
		
		var server_datetime = (user_date.getUTCMonth()+1)+"/"+user_date.getUTCDate()+"/"+user_date.getUTCFullYear()+" "+user_date.getUTCHours()+':'+user_date.getUTCMinutes()+':'+user_date.getUTCSeconds();
		
		server_datetime = new Date(server_datetime);
		
		server_datetime.setHours(server_datetime.getHours() + 5);
		server_datetime.setMinutes(server_datetime.getMinutes() + 30);
				
		var publish_datetime = (user_date.getUTCMonth()+1)+"/"+user_date.getUTCDate()+"/"+user_date.getUTCFullYear()+" "+publishing_time;		
		publish_datetime = new Date(publish_datetime);		
			
		
		var midnightDate = new Date(server_datetime);		
		midnightDate.setHours(0);
		midnightDate.setMinutes(0);
		midnightDate.setSeconds(0);
		
		if(user_date > midnightDate && user_date < publish_datetime){
			var currentDate = new Date(server_datetime);	
			date = currentDate.setDate(new Date().getDate() -1);
		}
		var server_date = today.getUTCFullYear()+"-"+(today.getUTCMonth()+1)+"-"+today.getUTCDate()+" 00:00:00";
		
		var selected_date = new Date(date);
		selected_date.setHours(0);
		selected_date.setMinutes(0);
		selected_date.setSeconds(0);			
			
		if(selected_date > server_date || (date >= server_date && publish_datetime > server_datetime)){
			window.location.href = process.env.BASE_URL;
			console.log('should redirect');
		}
		
      var self = this;
      db.collection("epaper")
        .where("paper_date", "==", this.$moment(date).format().substr(0, 10))
        .get()
        .then(function (querySnapshot) {
          if (!querySnapshot.empty) {
            querySnapshot.forEach(function (doc) {
              self.remoteGetPaper(doc.data());
            });
          } else {
            console.log("not found");
            self.$router.push({
              name: "NotFound",
            });
          }
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    async remoteGetPaper(p) {
      var self = this;
      const requestBody = {
        year: this.$moment(p.paper_date).format("YYYY"),
        month: this.$moment(p.paper_date).format("MM"),
        date: this.$moment(p.paper_date).format("DD"),
      };

      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      await axios
        .post(
          `${self.apibase}/island/api/epaper`,
          qs.stringify(requestBody),
          config
        )
        .then((response) => {
          self.pdf = response.data;
        })
        .catch((e) => {
          //this.errors.push(e);
          console.log(e);
        });
    },
    onPageChanged({ currentPage, numPages }) {
      console.log("Page", currentPage + "/" + numPages);
    },
  },
  mounted() {
    this.getPaper(this.paperDate);
  },
};
</script>